// ローディング判定
jQuery(window).on("load", function() {
  jQuery(function() {
    let swipeOption = {
      /*       loop: true,
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }, */
      loop: true,
      slidesPerView: 1,
      preloadImages: false,
      lazy: {
        loadPrevNext: true
      },
      speed: 1500,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button_next", // 「次へ」ボタン要素のクラス
        prevEl: ".swiper-button_prev" // 「前へ」ボタン要素のクラス
      },
      breakpoints: {
        // ブレークポイント
        768: {
          // 画面幅600px以上で適用
          slidesPerView: 2
        },
        1025: {
          // 画面幅1025px以上で適用
          slidesPerView: 3,
          spaceBetween: 0
        }
      }
    };
    new Swiper(".swiper", swipeOption);
  });
});
